<!-- loader starts-->
<div class="loader-wrapper" [class.d-none]="!show">
  <div class="loader"></div>
</div>
<!-- loader ends-->